import { NgModule } from '@angular/core';
import { provideLottieOptions } from 'ngx-lottie';

export function playerFactory() {
	return import('lottie-web');
}

@NgModule({
	providers: [provideLottieOptions({ player: playerFactory })],
})
export class AppLottieModule {}
